export default __webpack_public_path__ + "static/media/four-star.8d547463.svg";